import { Reveal, ClipReveal, Tag, LineReveal, ArrowLink } from "../components/Shared";
import { IMAGES } from "../data/content";

const CHAPTERS = [
  { n: "01", title: "INNOVATIVE PRINTS", body: "Pattern with a point of view — statements drawn from memory, geometry and Indian texture." },
  { n: "02", title: "INCLUSIVE SILHOUETTES", body: "Cut for real bodies and real entrances. Proportion as a language, not a rulebook." },
  { n: "03", title: "CLASSIC STYLES, RE-CUT", body: "Timeless forms, edited with a contemporary hand. Heritage, tailored for now." },
];

const House = () => (
  <section className="relative bg-ink px-5 py-28 sm:px-10 md:py-40" data-testid="house-section">
    <div className="mx-auto max-w-[1600px]">
      <Reveal><Tag>The House</Tag></Reveal>

      <div className="mt-10 grid gap-16 lg:grid-cols-2 lg:gap-24">
        <div>
          <LineReveal
            lines={["MORE THAN CLOTH.", "A POINT OF VIEW."]}
            className="font-serif text-5xl font-light leading-[1.02] tracking-tight sm:text-6xl lg:text-7xl"
            lineClassName=""
          />
          <Reveal delay={0.3} className="mt-10 max-w-md">
            <p className="text-lg font-light leading-relaxed text-fog" data-testid="house-intro-copy">
              Rutu Bhonsle creates fashion that moves between worlds — rooted in Indian craft, shaped by
              contemporary silhouettes, and designed for the individual who refuses to blend into the background.
            </p>
          </Reveal>
          <Reveal delay={0.45} className="mt-10">
            <ArrowLink to="/designer" testId="discover-designer-link" big>Discover the Designer</ArrowLink>
          </Reveal>

          <div className="mt-20 space-y-0 border-t border-line/10">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <div className="group grid grid-cols-[64px_1fr] items-baseline gap-4 border-b border-line/10 py-7 transition-colors duration-500 hover:border-flame/40" data-testid={`manifesto-chapter-${c.n}`}>
                  <span className="font-mono text-sm text-flame">{c.n}</span>
                  <div>
                    <h3 className="font-serif text-2xl font-normal tracking-wide transition-colors duration-300 group-hover:text-flame">{c.title}</h3>
                    <p className="mt-2 max-w-md text-sm font-light leading-relaxed text-fog">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="relative">
          <ClipReveal src={IMAGES.house} alt="Inside the Rutu Bhonsle studio — where every commission begins" className="aspect-[4/5] lg:sticky lg:top-28" imgClassName="transition-transform duration-[1.4s] ease-out hover:scale-105" />
          <Reveal delay={0.5} className="absolute -bottom-6 left-5 bg-ink px-6 py-4 sm:left-10">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-fog">The House Studio — <span className="text-flame">Every stitch has a story</span></p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default House;
